import { render, staticRenderFns } from "./CopyNovelDialog.vue?vue&type=template&id=7d19b664&scoped=true"
import script from "./CopyNovelDialog.vue?vue&type=script&lang=ts"
export * from "./CopyNovelDialog.vue?vue&type=script&lang=ts"
import style0 from "./CopyNovelDialog.vue?vue&type=style&index=0&id=7d19b664&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d19b664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d19b664')) {
      api.createRecord('7d19b664', component.options)
    } else {
      api.reload('7d19b664', component.options)
    }
    module.hot.accept("./CopyNovelDialog.vue?vue&type=template&id=7d19b664&scoped=true", function () {
      api.rerender('7d19b664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/CopyNovelDialog.vue"
export default component.exports